import React from "react";

import PageError from "src/components/Errors/PageError.tsx";
import { emitReload } from "src/hooks/useEvents.ts";
import { useT } from "src/internationalization";

const Page502: React.FC = () => {
  const t = useT();

  return (
    <PageError
      title={t("page.server.unavailable.title")}
      description={t("page.server.unavailable.description")}
      onClick={() => emitReload()}
    />
  );
};

export default Page502;
